import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import i18n from './i18n'
// pdf
import htmlToPdf from './utils/htmlToPdf.js'
import languageTransfor from './utils/languageTransfor.js'
import {
    navRouterState
} from './utils/navRouterState.js'
// api
import _api from './api/_api'
import Fragment from 'vue-fragment'
import {
    library
} from '@fortawesome/fontawesome-svg-core'
import {
    faFile,
    faCheck,
    faExclamation
} from '@fortawesome/free-solid-svg-icons'
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
// Tooltip
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/css/index.css'

Vue.use(Tooltip)
Vue.use(Fragment.Plugin)
library.add([faFile, faCheck, faExclamation])
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(htmlToPdf)
Vue.use(languageTransfor)
Vue.use(_api)
Vue.prototype._api = _api
Vue.prototype.navRouterState = navRouterState
// 处理页面刷新保存一些数据
window.addEventListener('beforeunload',
    () => {
        sessionStorage.setItem('appId', store.state.appId)
        window.scrollTo({
            top: 0,
            left: -1,
            behavior: 'instant'
        })
        document.body.scrollTop = 0
    })
// 一些权限管理
router.beforeEach((to, from, next) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    if (to.name === 'userLogin') {
        store.state.borderStyle = 'login'
        localStorage.setItem('clickState', 'login')
    } else {
        store.state.borderStyle = null
        localStorage.setItem('clickState', null)
    }
    // 后台导航状态
    to.matched[0] && to.matched[0].meta && to.matched[0].meta.navObj && navRouterState(to.matched[0].meta.navObj, true)
    // 判断是否有token 是否能进入 (token, registeredDetail)
    let loginTrue = sessionStorage.getItem('registeredDetail')
    let tokenTrue = localStorage.getItem('token')
    if (to.name === 'inviteVerify' && to.query && to.query.code) {
        localStorage.setItem('inviteCode', to.query.code)
        localStorage.setItem('inviteEmail', to.query.email)
    }
    let inviteCode = localStorage.getItem('inviteCode')

    // 允许进入 有token认证 和 已登录(能访问后台项目)
    if (loginTrue && loginTrue === 'true' && tokenTrue && tokenTrue !== 'null') {
        store.state.isFrontHeaderShow = false
        if (inviteCode && to.name !== 'inviteVerify') {
            store.state.isFrontHeaderShow = true
            store.state.isFooterShow = true
            next({
                name: 'inviteVerify'
            })
        } else if (to.name === 'inviteVerify') {
            store.state.isFrontHeaderShow = true
            store.state.isFooterShow = true
        }
        if (to.meta.requiresAuth && to.name !== 'updatePassword') {
            // (登陆后不不允许跳转登陆模块)
            next({
                name: 'MyProjectsList'
            })
        } else {
            next()
        }
    } else if (to.meta.requiresAuth) {
        if (to.name === 'updatePassword') {
            next({
                name: 'userLogin'
            })
        } else {
            next()
        }
        // 没有token 但是登陆模块(能访问登陆模块)
        store.state.isFrontHeaderShow = true
        store.state.isFooterShow = false
    } else {
        // 没有token 没有requiresAuth 直接跳到login页面
        if (inviteCode) {
            next({
                name: 'userRegister'
            })
        } else if (to.name === 'userLogin') {
            next()
        } else {
            store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
            next({
                name: 'userLogin'
            })
        }
    }
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
